<template>
  <div>
    <apexchart type="pie" :options="options" :series="series" :width="largura"></apexchart>
    {{preencherGrafico}}
  </div>
</template>
<script>
/* eslint-disable */
import VueApexCharts from "vue-apexcharts";
import Dexie from "dexie";
import BibliotecaDeCalculos from "bibliotecadecalculos-f02";
import DadosRecursosAnimais from "../../class/DadosRecursosAnimais.js";
import DadosRecursosInstalacoes from "../../class/DadosRecursosInstalacoes.js";
import DadosRecursosMaquinas from "../../class/DadosRecursosMaquinas.js";
import DadosRecursosPastagensOutros from "../../class/DadosRecursosPastagensOutros.js";
import RebanhoDeReproducao from "../../class/RebanhoDeReproducao.js";

export default {
  components: {
    apexchart: VueApexCharts
  },
  data: () => ({
    options: {
      legend: {
        position: "top"
      },
      colors: [
        "#BF343F",
        "#A7E4F2",
        "#32736C",
        "#D9B504",
        "#F2811D",
        "#BFBFBF"
      ],
      labels: [
        "Pastagens e capineiras",
        "Instalações e benfeitorias",
        "Máquinas e equipamentos",
        "Reprodutores (touros)",
        "Matrizes",
        "Animais de trabalho"
      ],
      dataLabels: {
        enabled: true,
        formatter: function(val) {
          return (
            parseFloat(val.toFixed(2)).toLocaleString("pt-BR", {
              currency: "BRL"
            }) + " %"
          );
        }
      },
      tooltip: {
        y: {
          formatter: function(val) {
            return parseFloat(val).toFixed(2) + " %";
          }
        }
      }
    },
    series: [0, 0, 0, 0, 0, 0],
    largura: "100%",
    comprimento: "200%",
    formulario: "",
    simulation: ""
  }),

  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    preencherGrafico: function() {
      this.$db.simulation
        .get({ code: this.simulation.code }, dado => {
          var pastagens = new DadosRecursosPastagensOutros(
            dado.dadosRecursosPastagensOutros
          );
          var instalacoes = new DadosRecursosInstalacoes(
            dado.dadosRecursosInstalacoes
          );
          var maquinas = new DadosRecursosMaquinas(dado.dadosRecursosMaquinas);
          var animais = new DadosRecursosAnimais(dado.dadosRecursosAnimais);
          var rebanhoReproducao = new RebanhoDeReproducao(
            dado.rebanhoReproducao
          );

          var biblioteca = [
            BibliotecaDeCalculos.CalculosDosGraficos(
              BibliotecaDeCalculos.RecursosPastagens(pastagens),
              BibliotecaDeCalculos.RecursosInstalacoes(instalacoes),
              BibliotecaDeCalculos.RecursosMaquinas(maquinas),
              BibliotecaDeCalculos.RecursosAnimais(animais),
              BibliotecaDeCalculos.RebanhoDeReproducao(rebanhoReproducao),
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              ""
            )
          ];

          return biblioteca;
        })
        .then(
          g => (
            (this.series[0] =
              (g[0].totalDepreciacaoPastagens() / g[0].totalDepreciacoes()) *
              100),
            (this.series[1] =
              (g[0].totalDepreciacaoInstalacoes() / g[0].totalDepreciacoes()) *
              100),
            (this.series[2] =
              (g[0].totalDepreciacaoMaquinas() / g[0].totalDepreciacoes()) *
              100),
            (this.series[3] =
              (g[0].valorDepreciacaoPorAnimal("touros") /
                g[0].totalDepreciacoes()) *
              100),
            (this.series[4] =
              (g[0].valorDepreciacaoPorAnimal("vacas") /
                g[0].totalDepreciacoes()) *
              100),
            (this.series[5] =
              ((g[0].valorDepreciacaoPorAnimal("equinos") +
                g[0].valorDepreciacaoPorAnimal("muares")) /
                g[0].totalDepreciacoes()) *
              100)
          )
        );
    }
  }
};
</script>
<style scoped>
</style>
